import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { StoredPayMethod } from './stored-pay-method'
import { storedPayMethodActions } from './stored-pay-method.actions'
import * as fromStoredPayMethod from './stored-pay-method.reducer'
import { StoredPayMethodService } from './stored-pay-method.service'

@Injectable()
export class StoredPayMethodEffects extends ResourceEffects<StoredPayMethod> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public storedPayMethodService: StoredPayMethodService
  ) {
    super(
      fromStoredPayMethod.FEATURE_NAME,
      storedPayMethodService,
      storedPayMethodActions,
      actions$
    )
  }
}
